import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import ProjectCard from "../../components/Boxs/ProjectCard";
import Page from "../../components/Page";
import Sidebar from "../../components/Sidebar";
import SidebarDrawer from "../../components/SidebarDrawer";
import { url } from "../../url";
import { projectsAtom } from "../Projects/atoms/ProjectAtomGlobal";
import { userProjectsAtom } from "../Projects/atoms/UserProjectAtomGlobal";
import styles from "./project.module.scss"; // to fix

// DODANE: Funkcja do pobierania posortowanych projektów z Flask
async function fetchSortedProjects(filter: any) {
  const res = await fetch("https://embedding-api-dot-smart-setting-448914-d9.lm.r.appspot.com/sort", { // TODO Change urls for prod in .env
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ type: "project", filter }),
  });
  return await res.json();
}

const FoundProjects = () => {
  const [projects, setProjects] = useAtom(projectsAtom);
  const [userProjects, setUserProjects] = useAtom(userProjectsAtom);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [index, setIndex] = useState(2);
  const [filterValues, setFilterValues] = useState<any>({}); // DODANE: stan filtrów
  const [sortedResults, setSortedResults] = useState<any[]>([]); // DODANE: posortowane projekty
  const [loadingSort, setLoadingSort] = useState(false); // DODANE: loading dla sortowania
  const [classicFiltered, setClassicFiltered] = useState<any[]>([]); // Dodane: klasyczne filtrowanie
  const [showMagicSort, setShowMagicSort] = useState(false); // Dodane: czy pokazywać AI fallback
  const [noClassicResults, setNoClassicResults] = useState(false); // Dodane: czy nie ma klasycznych wyników

  const navigate = useNavigate();

  useEffect(() => {
    console.log('Render: Filters');
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const projects = await axios.get(url + "/project", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setProjects(projects.data.projects);

      const token = localStorage.getItem("token");
      if (token) {
        const userProjects = await axios.get(
          url + `/user/projects/found?page=${currentPage}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setUserProjects(userProjects.data.projects);
        const morePages = userProjects.data.projectPages == 1 ? false : true;
        if (!morePages) {
          setHasMore(false);
        }
      }
    };
    fetchData()
  }, [currentPage, setProjects, setUserProjects]);

  const handlePageChange = (value: number) => {
    setCurrentPage(value);
  };

  const fetchMoreProjects = async () => {
    await axios
      .get(url + `/user/projects/found?page=${currentPage}`)
      .then((res) => {
        const projectsArr = res.data.projects;
        setProjects((prevProjects: any[]) => [...prevProjects, ...projectsArr]);

        projectsArr?.length > 0 ? setHasMore(true) : setHasMore(false);
      })
      .catch((err) => console.error(err));

    setIndex((prevIndex) => prevIndex + 1);
  };

  const deleteFoundedProject = async (project: any) => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await axios.delete(url + `/user/projects/${project._id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        setUserProjects(
          userProjects.filter(function (p: any) {
            return p !== project._id;
          })
        );
      } catch (err) {
        console.log(err);
      }
    }
  };

  // DODANE: Handler do obsługi Apply Filters
  const handleApplyFilters = async () => {
    setLoadingSort(true);
    setShowMagicSort(false);
    setNoClassicResults(false);
    setSortedResults([]);
    console.log('Apply: start');
    // Timeout fallback na wypadek zawieszenia
    const timeout = setTimeout(() => {
      setLoadingSort(false);
      console.log('Apply: timeout fallback (5s)');
    }, 5000);
    // Klasyczne filtrowanie po stronie frontendu
    const filtered = projects.filter((project: any) => {
      const skillsOk = !filterValues.skills || filterValues.skills.length === 0 || (project.skills && filterValues.skills.every((s: string) => project.skills.includes(s)));
      const locationOk = !filterValues.location || !project.location || project.location === filterValues.location;
      const industryOk = !filterValues.industry || !project.industry || project.industry === filterValues.industry;
      return skillsOk && locationOk && industryOk;
    });
    setClassicFiltered(filtered);
    console.log('Apply: classicFiltered', filtered);
    if (filtered.length === 0) {
      setNoClassicResults(true);
      // Wywołaj MAGIC_SORT
      try {
        console.log('Apply: calling MAGIC_SORT');
        const data = await fetchSortedProjects(filterValues);
        console.log('Apply: MAGIC_SORT result', data);
        setSortedResults(data.results || []);
        setShowMagicSort(true);
      } catch (e) {
        console.log('Apply: MAGIC_SORT error', e);
        setSortedResults([]);
        setShowMagicSort(true);
      }
      setLoadingSort(false);
      clearTimeout(timeout);
      console.log('Apply: end (MAGIC_SORT)');
    } else {
      setShowMagicSort(false);
      setLoadingSort(false);
      clearTimeout(timeout);
      console.log('Apply: end (classic)');
    }
  };

  // DODANE: Przykładowy prosty formularz filtrów (do rozbudowy)
  // W prawdziwej aplikacji podłącz tu swoje komponenty filtrów
  const Filters = () => (
    <div style={{ marginBottom: 24 }}>
      <input
        placeholder="Skills (comma separated)"
        onChange={e => setFilterValues((f: any) => ({ ...f, skills: e.target.value.split(",").map((s: string) => s.trim()).filter(Boolean) }))}
      />
      <input
        placeholder="Location"
        onChange={e => setFilterValues((f: any) => ({ ...f, location: e.target.value }))}
      />
      <input
        placeholder="Industry"
        onChange={e => setFilterValues((f: any) => ({ ...f, industry: e.target.value }))}
      />
      <Button variant="contained" onClick={() => { console.log('Kliknięto APPLY'); handleApplyFilters(); }} style={{ marginLeft: 8 }}>
        Apply Filters
      </Button>
    </div>
  );

  return (
    <Page>
      <div className={styles.foundProjects}>
        <header className="foundSkillers__header">
          <div className="foundSkillers__header__sidebar">
            <SidebarDrawer />
          </div>
        </header>
        <div className="foundSkillers__container">
          <div className="foundSkillers__container__sidebar">
            <Sidebar />
          </div>
          <div className="foundSkillers__container__skills">
            {/* DODANE: Filtry na górze */}
            {loadingSort ? (
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32 }}><CircularProgress /></div>
            ) : showMagicSort ? (
              <>
                <div style={{ textAlign: 'center', margin: '2rem 0 1rem 0', color: '#374151', fontWeight: 500 }}>
                  Sorry, we couldn't find any project meeting your criteria. Check out closest match.
                </div>
                {sortedResults.length > 0 ? (
                  <div className={styles.gridContainer}>
                    {sortedResults.map((result: any) => {
                      const project = projects.find((p: any) => p._id === result.record_id);
                      if (!project) return null;
                      return (
                        <div key={project._id} className={styles.projectCard}>
                          <ProjectCard
                            project={project}
                            tokenAvailable={true}
                            projectAdded={true}
                            deleteProject={() => deleteFoundedProject(project)}
                          />
                          <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>Similarity: {result.similarity.toFixed(3)}</div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div style={{ textAlign: 'center', color: '#888', marginTop: 32 }}>No close matches found.</div>
                )}
              </>
            ) : classicFiltered.length > 0 ? (
              <div className={styles.gridContainer}>
                {classicFiltered.map((project: any) => (
                  <div key={project._id} className={styles.projectCard}>
                    <ProjectCard
                      project={project}
                      tokenAvailable={true}
                      projectAdded={true}
                      deleteProject={() => deleteFoundedProject(project)}
                    />
                  </div>
                ))}
              </div>
            ) : userProjects?.length === 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center' }}>
                <h2 style={{ marginBottom: '2rem', fontSize: '1.8rem', color: '#374151', fontWeight: '400' }}>No projects added...</h2>
                <Button
                  onClick={() => navigate("/find")}
                  variant="contained"
                  size="large"
                  style={{
                    width: '280px',
                    height: '80px',
                    fontSize: '1.2rem',
                    fontWeight: '500',
                    borderRadius: '6px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)',
                    transition: 'all 0.3s ease',
                    textTransform: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 12px 35px rgba(102, 126, 234, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.3)';
                  }}
                >
                  Find Projects
                </Button>
              </div>
            ) : (
              <div className={styles.gridContainer}>
                <InfiniteScroll
                  dataLength={userProjects?.length ? userProjects.length : 0}
                  next={fetchMoreProjects}
                  hasMore={hasMore}
                  loader={<CircularProgress />}
                  style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))', gap: '2rem' }}
                >
                {projects.filter((project: any) => userProjects?.includes(project._id)).map((project: any) => (
                  <div key={project._id} className={styles.projectCard}>
                    <ProjectCard
                      project={project}
                      tokenAvailable={true}
                      projectAdded={true}
                      deleteProject={() => deleteFoundedProject(project)}
                    />
                  </div>
                ))}
                </InfiniteScroll>
              </div>
            )}
          </div>
        </div>
      </div>
    </Page>
  );
};

export default FoundProjects;
